import {GetH1} from "./src-outline-helper";

/**
 * the entry point
 */
const CRSOutlineBoxMessage = () => {



    return (

            <>
                {
                        <div className="info-box mb-10"><p>
                        This course is based on materials covered in the <a href="/courses/waves-mixing-foundations " className="blue9-link">Waves Mixing Foundations</a> course, which is included FREE with your purchase.
                        To get the most out of {GetH1()}, it is highly recommended that you first complete Waves Mixing Foundations course.</p>
                        </div>
                }
            </>
    )
};

export default CRSOutlineBoxMessage;